/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Status_ApprovedInputs */

const vi_product_lot_status_approved = /** @type {(inputs: Product_Lot_Status_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã duyệt`)
};

/**

* @param {Product_Lot_Status_ApprovedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_status_approved = /** @type {((inputs?: Product_Lot_Status_ApprovedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Status_ApprovedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_status_approved(inputs)
});